import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import ActionButton from "./ActionButton";
import { UserProps } from "../../store/actionType";


export const TableColumns: ColumnDef<UserProps>[] = [

  {
    id: "slNo",
    header: "Sl. No",
    cell: ({ row }) => row.index + 1,
  },
  {
      accessorFn: (row) => row?.name,
      id: "name",
      cell: (info) => info.getValue(),
      header: () => <span>User Name</span>,
      filterFn: "equalsString",
    },
  {
      accessorFn: (row) => row?.email,
      id: "email",
      cell: (info) => info.getValue(),
      header: () => <span>Email</span>,
      filterFn: "equalsString",
    },
  {
      accessorFn: (row) => row?.mobile_no,
      id: "mobile_no",
      cell: (info) => info.getValue(),
      header: () => <span>Mobile No.</span>,
      filterFn: "equalsString",
    },
  {
      accessorFn: (row) => row?.roles?.map((role) => role.name).join(", "),
      id: "roles",
      cell: (info) => info.getValue(),
      header: () => <span>Role</span>,
      filterFn: "equalsString",
    },
  {
      accessorFn: (row) => row?.status,
      id: "status",
      cell: (info) => info.getValue(),
      header: () => <span>Status</span>,
      filterFn: "equalsString",
    },
  {
    id: "action",
    cell: ({ row }) => {
      return (
      <div className="flex justify-center items-center gap-2">
        <ActionButton items={row.original} />
      </div>
    )},
    header: () => <span>Actions</span>,
    enableSorting: false,
  },
];
